export default __webpack_public_path__ + "static/media/01.0e0537c7.jpg";